export const messages = {
  title: '家庭日历',
  add: '添加事件',
  month: '月',
  empty: '本月无事件',
  titleLabel: '标题',
  dateLabel: '日期',
  category: '分类',
  save: '保存',
  cancel: '取消'
} as const
